import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-slate-50" data-id="element-62" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-63" data-mp="1cf9ko959c1gj">
        <div className="text-center mb-16" data-id="element-64" data-mp="1cgb7favmyce3">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-blue-950" data-id="element-65" data-mp="2a2s4cf0ginzb">
            ❓ Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-66" data-mp="253xa8gx1hczw">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-white border border-amber-500/40 rounded-xl overflow-hidden shadow-sm shadow-blue-700/10" data-id="element-67" data-mp="202rhij3dppqd" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-700" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-68" data-mp="opfc43rz0z23">
                <span className="font-bold text-lg text-blue-950 pr-8" data-id="element-69" data-mp="1apsuuvn0tnac">{faq.q}</span>
                <ChevronDown className={`text-amber-500 transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-70" data-mp="1arx0bi0kiucq" />
              </button>
              <AnimatePresence initial={false} data-id="element-71" data-mp="16oquucla577b">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-72" data-mp="s0431begumz7">
                    <div className="px-6 pb-5 text-slate-600 border-t border-amber-500/30 pt-4 space-y-2" data-id="element-73" data-mp="n1sv567qemjm">
                      {faq.a.map(paragraph => <p key={paragraph} data-id="element-74" data-mp="2kv52b42wjnd2">{paragraph}</p>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}